import React, { useEffect, useState } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import DefaultLayout from "./components/Layout/DefaultLayout";
import Loader from "./common/Loader";
import PageTitle from "./components/PageTitle";
import Owner from "./pages/Master/Owner";
import Architect from "./pages/Master/Architect";
import Fabricator from "./pages/Master/Fabricator";
import Item from "./pages/Master/Item";
import Sitedetails from "./pages/SiteDetails/index.jsx";
import Details from "./pages/SiteDetails/Details.jsx";
import WindowQuotation from "./pages/Quotes/WindowQuotation.jsx";
import ManualQuotation from "./pages/Quotes/ManualQuotation.jsx";
import Terms from "./pages/Master/Terms";
import ManualDetails from "./pages/Quotes/ManualDetails.jsx";
import CalendarComponent from "./components/Header/CalendarComponent";
import Customer from "./pages/Master/Customer";
import MaterialDetails from "./pages/Quotes/MaterialDetails.jsx";
import UserMaster from "./pages/Settings/UserMaster";
import SignIn from "./pages/Authentication/Signin";
import axiosInstance from "./api/axiosInstance.js";
import { notify, Toast } from "./common/Toast/index.js";
import ActivityLog from "./pages/Settings/ActivityLog.jsx";
import MaterialQuotation from "./pages/Quotes/MaterialQuotation.jsx";
import ActiveDetails from "./pages/Quotes/ActiveDetails.jsx";
import MenuTable from "./pages/Settings/MenuTable.jsx";
import ViewDetails from "./pages/SiteDetails/ViewDetails.jsx";
import Dashboard from "./pages/Dashboard/index.jsx";
import Reports from "./pages/Reports/index.jsx";
import CoatingType from "./pages/Master/CoatingType.jsx";
import FinsItem from "./pages/Master/FinsItem.jsx";
import FinsMaterialQuotation from "./pages/Quotes/FinsMaterialQuotation.jsx";
import FinsMaterialDetails from "./pages/Quotes/FinsMaterialDetails.jsx";

function App() {
  const [loading, setLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(
    !!localStorage.getItem("userId")
  );
  const navigate = useNavigate();

  useEffect(() => {
    setTimeout(() => setLoading(false), 1000);
  }, []);

  useEffect(() => {
    if (!loading && !isAuthenticated) {
      navigate("/signin", { replace: true });
    }
  }, [isAuthenticated, loading, navigate]);

  const handleLogin = async (userName, encryptPassword) => {
    setLoading(true);
    try {
      const response = await axiosInstance.post("User/login", {
        userName,
        encryptPassword,
      });

      localStorage.setItem("userName", userName);
      localStorage.setItem("userId", response.data.userId);

      if (response.data.userId === 1) {
        localStorage.setItem("userMenuPermissions", "ALL");
      } else {
        const permissions = response.data.permissions || [];
        localStorage.setItem(
          "userMenuPermissions",
          JSON.stringify(permissions)
        );
      }

      setIsAuthenticated(true);
      navigate("/");
    } catch (error) {
      notify("Login failed");
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = () => {
    localStorage.clear();
    setIsAuthenticated(false);
  };

  return (
    <>
      <Toast />
      {loading ? (
        <Loader />
      ) : isAuthenticated ? (
        <DefaultLayout onLogout={handleLogout}>
          <Routes>
            {/* <Route path="/" element={<Navigate to="/dashboard" replace />} /> */}
            {/* <Route path="/" index /> */}
            <Route
              path="/dashboard"
              element={
                <>
                  <PageTitle title="Dashboard" />
                  <Dashboard />
                </>
              }
            />
            <Route
              path="/master/owner"
              element={
                <>
                  <PageTitle title="Owner" />
                  <Owner />
                </>
              }
            />
            <Route
              path="/master/architect"
              element={
                <>
                  <PageTitle title="Architect" />
                  <Architect />
                </>
              }
            />
            <Route
              path="/master/fabricator"
              element={
                <>
                  <PageTitle title="Fabricator" />
                  <Fabricator />
                </>
              }
            />
            <Route
              path="/master/item"
              element={
                <>
                  <PageTitle title="Item" />
                  <Item />
                </>
              }
            />
            <Route
              path="/master/terms"
              element={
                <>
                  <PageTitle title="Terms" />
                  <Terms />
                </>
              }
            />
            <Route
              path="/master/customer"
              element={
                <>
                  <PageTitle title="Customer" />
                  <Customer />
                </>
              }
            />
            <Route
              path="/master/CoatingType"
              element={
                <>
                  <PageTitle title="Coating-Type" />
                  <CoatingType />
                </>
              }
            />
            <Route
              path="/master/fins-item"
              element={
                <>
                  <PageTitle title="FinsItem" />
                  <FinsItem />
                </>
              }
            />
            <Route
              path="/transaction/sites"
              element={
                <>
                  <PageTitle title="Sitedetails" />
                  <Sitedetails />
                </>
              }
            />
            <Route
              path="/transaction/site-details"
              element={
                <>
                  <PageTitle title="Sites-details" />
                  <Details />
                </>
              }
            />
            <Route
              path="/transaction/siteview-details"
              element={
                <>
                  <PageTitle title="Sites-details" />
                  <ViewDetails />
                </>
              }
            />
            <Route
              path="/quotes/window-quotation"
              element={
                <>
                  <PageTitle title="Window-Quotation" />
                  <WindowQuotation />
                </>
              }
            />
            <Route
              path="/quotes/window-quotation/active-details"
              element={
                <>
                  <PageTitle title="Window-Details" />
                  <ActiveDetails />
                </>
              }
            />
            <Route
              path="/quotes/manual-quotation"
              element={
                <>
                  <PageTitle title="Manual-Quotation" />
                  <ManualQuotation />
                </>
              }
            />
            <Route
              path="/quotes/manual-quotation/manual-details"
              element={
                <>
                  <PageTitle title="Manual-Details" />
                  <ManualDetails />
                </>
              }
            />
            <Route
              path="/quotes/material-quotation"
              element={
                <>
                  <PageTitle title="Material-Quotation" />
                  <MaterialQuotation />
                </>
              }
            />
            <Route
              path="/quotes/material-quotation/material-Details"
              element={
                <>
                  <PageTitle title="Material-Details" />
                  <MaterialDetails />
                </>
              }
            />
            <Route
              path="/quotes/fins-quotation"
              element={
                <>
                  <PageTitle title="Fins-Quotation" />
                  <FinsMaterialQuotation />
                </>
              }
            />
            <Route
              path="/quotes/fins-quotation/fins-Details"
              element={
                <>
                  <PageTitle title="Fins-Details" />
                  <FinsMaterialDetails />
                </>
              }
            />
            <Route
              path="/settings/user-master"
              element={
                <>
                  <PageTitle title="User-Master" />
                  <UserMaster />
                </>
              }
            />
            <Route
              path="/settings/activitylog"
              element={
                <>
                  <PageTitle title="Activity-Log" />
                  <ActivityLog />
                </>
              }
            />
            <Route
              path="/settings/menu-permission"
              element={
                <>
                  <PageTitle title="Menu-Permission" />
                  <MenuTable />
                </>
              }
            />
            <Route
              path="/calendar"
              element={
                <>
                  <PageTitle title="calendar" />
                  <CalendarComponent />
                </>
              }
            />
            <Route
              path="/reports"
              element={
                <>
                  <PageTitle title="Reports" />
                  <Reports />
                </>
              }
            />
          </Routes>
        </DefaultLayout>
      ) : (
        <SignIn onLogin={handleLogin} />
      )}
    </>
  );
}

export default App;
